import cn from "classnames";
import { ViewType } from "../types";
import { NumberBlockProps } from "./types";
import styles from "./styles.scss";

export const NumberBlock = ({
  index,
  type,
  hover,
  rating,
  active,
}: NumberBlockProps) => {
  const hasHover = hover !== -1;
  let viewType: ViewType;

  if (hasHover) {
    if (index <= (hover ?? rating)) {
      viewType = "action-positive";
    } else {
      viewType = "action-negative";
    }
  } else if (index <= rating && rating !== -1) {
    viewType = "default-positive";
  } else {
    viewType = "default-negative";
  }

  if (rating === -1 && !hasHover) {
    viewType = "default";
  }

  if (index === rating && !hasHover && type === "number-monochrome") {
    viewType = "click-positive";
  }

  if (index === active) {
    viewType = "click-positive";
  }

  return (
    <div
      className={cn(
        styles["number-container"],
        styles[`number-container-${index}`],
        styles[viewType],
        styles[type]
      )}
    >
      <span
        className={cn(
          styles.number,
          styles[`number-${index}`],
          styles[viewType],
          styles[type]
        )}
      >
        {index}
      </span>
    </div>
  );
};
